<div
    class="inner-content"
    [ngClass]="{
        'landscape-mode': (isInLandscapeMode | async) === true
    }"
    ridangoAppTrapFocus>
    <div class="h-full w-full bg-white">
        <div class="flex-align-center relative flex w-full border-b border-solid">
            <p class="align-center flex-1 font-semibold">{{ 'EDIT_FAVORITE_TICKETS_TITLE' | translate }}</p>
            <button
                class="!absolute !right-4 text-grey-zambezy"
                [attr.aria-label]="'CLOSE' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div
            class="content flex h-full flex-col gap-4 overflow-y-auto py-4 pl-4"
            [ngClass]="{
                'landscape-mode': (isInLandscapeMode | async) === true
            }">
            <div class="flex-align-center flex justify-between" *ngFor="let ticket of favoriteTicketsList">
                <div
                    class="flex-align-center box-border flex w-full gap-2 rounded-lg border-2 border-solid border-[#dcdcdc] bg-grey-white_smoke p-2 dark:bg-contrast-black">
                    <ion-icon
                        class="h-8 w-8"
                        *ngIf="ticket.categoryCode === 'SINGLE'"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_single_ticket.svg"></ion-icon>
                    <ion-icon
                        class="h-8 w-8"
                        *ngIf="ticket.categoryCode === 'PERIOD'"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_period_ticket.svg"></ion-icon>
                    <ion-icon
                        class="h-8 w-8"
                        *ngIf="ticket.categoryCode === 'MULTI_JOURNEY'"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product_multi_ticket.svg"></ion-icon>
                    <div class="flex-1">
                        <p class="text-xs">{{ 'TICKET_SUMMARY_V2_' + ticket.categoryCode | translate }}</p>
                        <p class="text-base font-bold">
                            {{
                                ticket?.translations
                                    ? (ticket | translateObjectField: 'name' : currentLanguage)
                                    : ticket.productName
                            }}
                        </p>
                    </div>
                </div>
                <ion-button class="next-button" (click)="openDeleteTicket(ticket)" fill="clear">
                    <ion-icon
                        class="text-primary"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/cart/icon-delete.svg"></ion-icon>
                </ion-button>
            </div>
        </div>
        <div
            class="border-t border-solid"
            [ngClass]="{
                'p-1': (isInLandscapeMode | async) === true,
                'p-4': (isInLandscapeMode | async) === false
            }">
            <button
                class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                [ngClass]="{
                    'h-8': (isInLandscapeMode | async) === true,
                    'h-14': (isInLandscapeMode | async) === false
                }"
                (click)="saveFavoriteTickets()"
                type="submit">
                {{ 'SAVE' | translate }}
            </button>
        </div>
    </div>
</div>
